"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageRoomCostForDate = void 0;
const dayjs = require("dayjs");
const getPackageRoomCostForDate = (date, pkg) => {
    if (!date) {
        date = dayjs().toISOString();
    }
    if (!pkg)
        return 0;
    let room_prices = pkg?.room?.prices.find((price) => {
        return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
            dayjs(date).unix() <= dayjs(price.to_date).unix());
    });
    if (!room_prices) {
        room_prices = pkg?.room?.prices[0];
    }
    const total = () => {
        let t = 0;
        t += (room_prices?.total || 0) / pkg.room.room_basis;
        return t;
    };
    // make sure the number is rounded and shows no decimals
    return total();
};
exports.getPackageRoomCostForDate = getPackageRoomCostForDate;
